export var isRefundPassenger = function (passenger) {
    return !('values' in passenger);
};
